<template>
  <section>
    <div class="mb-2">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="headline" v-text="content.title"></div>
          <div
            class="subtitle-1 grey--text text--darken-2"
            v-text="content.subtitle"
          ></div>
        </div>
        <template v-if="content.headerButton != null">
          <div class="flex-shrink-1">
            <v-btn text :color="$buttonColor" @click="more()">
              <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
              {{ content.headerButton.title }}
              <v-icon right small>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </div>
    <v-row>
      <template v-for="item of content.body">
        <v-col cols="12" md="6" lg="4" xl="4" :key="`cours_${item._id}`">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="hoverable card-growable"
              :elevation="hover ? 6 : 2"
              ripple
              @click="navigate(item)"
            >
              <v-img
                max-width="100%"
                width="auto"
                height="280px"
                :src="item.image"
                :lazy-src="item.image"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
                <template v-slot:default>
                  <v-row
                    align="end"
                    class="white--text fill-height bottom-gradient"
                  >
                    <v-col>
                      <v-card-subtitle
                        class="white--text subtitle-2 pb-3"
                        v-text="item.categories[0].title"
                      ></v-card-subtitle>
                      <div
                        style="max-height: 60px; overflow: hiden"
                        class="body-2 px-4 py-2"
                        v-text="item.title"
                      ></div>
                    </v-col>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>

    <template v-if="content.footerButton != null">
      <div class="mt-3">
        <v-btn :color="$buttonColor" large outlined @click="more()">
          <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
          {{ content.footerButton.title }}
          <v-icon right small>far fa-chevron-right</v-icon>
        </v-btn>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: "my_course_vertical_gridview",
  props: ["content", "list-view"],
  methods: {
    more() {
      const qs = this.$utility.queryStringToJson(
        this.content.footerButton
          ? this.content.footerButton.queries
          : this.content.headerButton.queries
      );
      this.$router.push({
        name: "my_course",
        query: qs,
      });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>